import styled from 'styled-components';

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0 auto;
  width: 100%;
`;

export const ActivityCard = styled.div`
  background-color: var(--white);
  border-radius: 5px;
  box-shadow: var(--shadow-inset-md);
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 0;
  min-height: 44px;
  padding: 5px 11px 7px;
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;
`;

export const Avatar = styled.img`
  align-self: center;
  border-radius: 50%;
  flex-shrink: 0;
  height: 35px;
  object-fit: cover;
  width: 35px;
`;

export const ActivityText = styled.div`
  color: var(--grey-600);
  display: block;
  flex: 1;
  font-family: var(--open-sans);
  font-size: 14px;
  font-weight: 300;
  margin-top: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;
  padding-bottom: 20px;
`;
